import { IconChartBar } from "@tabler/icons-react";
import styles from "../../pages/ClientDashboard/TeamManagement/teamManagement.module.css";

const ROLE_META = [
  { role: "Admin", colour: "#d97706" },
  { role: "Manager", colour: "#1d4ed8" },
  { role: "Member", colour: "#16a34a" },
  { role: "Viewer", colour: "#64748b" },
];

export default function RoleBreakdownCard({ users, totalAdmins }) {
  const totalUsers = users.length;

  const rows = ROLE_META.map(({ role, colour }) => {
    const count =
      role === "Admin"
        ? totalAdmins
        : users?.filter((u) => u?.role === role)?.length || 0;
    const pct = totalUsers > 0 ? Math.round((count / totalUsers) * 100) : 0;
    return { label: role, colour, count, pct };
  });

  return (
    <div className={styles.sidebarCard}>
      <div className={styles.sidebarCardHeader}>
        <IconChartBar size={17} />
        <span className={styles.sidebarCardTitle}>Role Breakdown</span>
      </div>
      <div className={styles.sidebarCardBody}>
        {rows?.map((row) => (
          <div className={styles.roleRow} key={row?.label}>
            <div className={styles.roleLabel}>
              <div
                className={styles.roleDot}
                style={{ background: row.colour }}
              />
              {row?.label}
            </div>
            <div className={styles.roleBarWrap}>
              <div
                className={styles.roleBar}
                style={{ width: `${row?.pct}%`, background: row?.colour }}
              />
            </div>
            <div className={styles.roleCount}>{row?.count}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
